<!-- 主页layout布局 -->
<template>
  <div class="content layout" :class="isAsideColor ? 'elAsideWhite' : ''">
    <el-container class="content">
      <el-container>
        <el-aside
          :style="{
            width: isCollapse ? closeWidth : openWidth,
          }"
        >
          <Sliber />
        </el-aside>
        <el-main>
          <div class="headerBox">
            <el-header>
              <Header />
            </el-header>
            <BreadCrumb />
          </div>

          <transition mode="out-in">
            <router-view />
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "./components/header.vue";
import Sliber from "./components/sliber.vue";
import BreadCrumb from "../components/BreadCrumb.vue";

import Bus from "@/utils/bus.js";
export default {
  name: "Layout",
  data() {
    return {
      isCollapse: true,
      closeWidth: "64px !important",
      openWidth: "200px !important",
      screenWidth: null,
    };
  },
  components: {
    Header,
    Sliber,
    BreadCrumb,
  },
  computed: {
    isAsideColor() {
      return this.$route.meta.asideColor;
    },
  },
  created() {
    this.$store.dispatch("user/roleList");
    this.$store.dispatch("user/subjectsList");
    this.getScreenWidth();

    Bus.$on("getListInfo", (data) => {
      // console.log("222---", data);
      this.isCollapse = data;
    });
  },
  watch: {
    //  监听屏幕大小变化979px
    screenWidth(val, oldVal) {
      if (val < 979) {
        console.log("小于979px");
        this.closeWidth = "0 !important";
      } else {
        console.log("大于979px");
        this.closeWidth = "64px !important";
      }
    },
  },
  mounted() {},
  methods: {
    getScreenWidth() {
      var screenWidth = document.body.clientWidth;
      if (screenWidth < 979) {
        this.isCollapse = true;
        this.closeWidth = "0 !important";
      } else {
        this.isCollapse = false;
        this.closeWidth = "64px !important";
      }
    },
    // getCollapse(e) {
    //   console.log("222---", e);
    // },
  },
};
</script>
<style lang="less" scoped>
// 布局样式
.layout {
  // background-color:#F3F4F8;
  /deep/ .el-header {
    height: 60px !important;
    background-color: #ffffff;
    color: #000000;
  }
  /deep/ .el-aside {
    background-color: #282637;
    // overflow: auto;
    width: 200px !important;
    box-sizing: border-box;
    transition: width 0.28s;
    overflow-x: hidden !important;
  }
  /deep/ .el-main {
    padding: 0;
    overflow: auto;
    box-sizing: border-box;
    // overflow: hidden;
  }
  /deep/ .el-container {
    overflow: auto;
  }
}
.elAsideWhite {
  background-color: #fff;
}
/deep/.headerBox {
  // position: fixed;
  // width: 100%;
  // top: 0;
  // left: 0;
  // z-index: 10;
}
/deep/ .el-menu--vertical .el-menu--popup-right-start {
  margin: 0 !important;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
}

/* 动画 */
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(10px);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.35s ease-in-out;
}
/* 动画 */

@media (max-width: 767px) {
  /deep/.left {
    .img {
      display: none !important;
    }
    .title {
      display: none !important;
    }
  }
  /deep/.right {
    span {
      margin-right: 0 !important;
    }
  }
  /deep/.el-menu-item {
    width: auto !important;
  }
  // /deep/.el-aside {
  // }
}
</style>
